<template>
  <div>
    <div v-for="(item) in signUpList" :key="item.id">
      <el-row>
        <el-col class="sign-outer-layer" :span="22">
          <el-col style="font-size: 18px;" :span="18">
            <el-col :span="12" class="sign-information">团队姓名：{{item.data.teaName}}</el-col>
            <el-col :span="12" class="sign-information">参赛项目：{{item.remark}}</el-col>
            <el-col :span="12" class="sign-information">队长名称：{{item.data.name}}</el-col>
            <el-col :span="12" class="sign-information">学校指导老师：{{item.data.teacherName}}</el-col>
          </el-col>
           <el-col :span="2">
            <el-button type="primary" style="margin: 20px;padding: 10px 15px" @click="Details(item.id,item.competitionProject,'show')">查看</el-button>
          </el-col>
           <el-col :span="2">
            <el-button type="primary" style="margin: 20px;padding: 10px 15px" @click="Details(item.id,item.competitionProject,'edit')">修改</el-button>
          </el-col>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {conditionByParticipantData} from '../../../api/registerForm'
import registerTearmComponents from '../form/registerTearmComponents.vue'

export default {
  components: { registerTearmComponents },
   name: "SignUpList",
  data () {
    return {
      signUpList: [],
    }
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      conditionByParticipantData(this.baseURL, {
        siteId: this.siteId,
        userId: this.$store.state.user.userId
      }).then((res) => {
        res.data.forEach(element => {
          let competition = parseInt(element.competitionProject)
          if (competition === 3) {
            element.remark = '创意作品-科技改变生活（中学组）'
          } else if (competition === 2) {
            element.remark = '科普实验-未来太空车（中学组）'
          } else if (competition === 1) {
            element.remark = '创意作品-人机协作（大学组）'
          }
          element.data = JSON.parse(element.data)
          this.signUpList.push(element)
        })
      })
    },
    Details( objId, objType, objStatus) {
      this.$router.push({
        path: '/preliminaryApply',
        query: { id: objId,workType:objType,workState:objStatus}
      });
    }
  }
}
</script>

<style scoped>
.sign-outer-layer{
  margin:15px;
  padding: 10px;
  background: white;
  border-radius: 5px;
}
.sign-information{
  padding:5px 0
}
</style>



// WEBPACK FOOTER //
// src/views/my/components/signUpList.vue